import { render, staticRenderFns } from "./CotDossierSanitarioPage.vue?vue&type=template&id=2a1b955a&scoped=true"
import script from "./CotDossierSanitarioPage.vue?vue&type=script&lang=js"
export * from "./CotDossierSanitarioPage.vue?vue&type=script&lang=js"
import style0 from "./CotDossierSanitarioPage.vue?vue&type=style&index=0&id=2a1b955a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1b955a",
  null
  
)

export default component.exports